import { SpaceBillingInfoSection } from '../../../../../components/service/subscription/manage/SpaceBillingInfoSection';
export const SpaceBillingHistoryPageView = () => {
  return <SpaceBillingInfoSection data-sentry-element="SpaceBillingInfoSection" data-sentry-component="SpaceBillingHistoryPageView" data-sentry-source-file="billing-history.tsx" />;
};